module.exports = __webpack_public_path__ + "img/Ascendis_logo@2x.ae24e4d9.png";